import React, { useContext, useState } from "react";
import { ThemeContext } from "styled-components";
import { DropMenu, DropMenuNotifications, Page } from "./styles";
import { BiMoon, BiBell, BiUser, BiSun, BiErrorCircle } from "react-icons/bi";
import { useAuth } from "../../hooks/auth";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { ModalCofirm } from "../ModalCofirm";
import { useTheme } from "../../hooks/useTheme";

const Header = () => {
  const { toggleTheme } = useTheme();
  const navigate = useNavigate();
  const { title } = useContext(ThemeContext);
  const { user, signOut } = useAuth();
  const [openModalSignOut, setOpenModalSignOut] = useState(false);
  function toProfile() {
    navigate("profile");
  }
  function toggleLogout() {
    setOpenModalSignOut(!openModalSignOut);
  }
  function handleProfileClick() {
    return (
      <DropMenu>
        <li onClick={toProfile}>Perfil</li>
        <li onClick={toggleLogout}>Sair</li>
      </DropMenu>
    );
  }
  function handleNotificantionClick() {
    return (
      <DropMenuNotifications>
        <div className="notifications">
          <div className="notification">
            <p>hoje as 18:04</p>
            <div className="notification-content">
                <div className="icon info">
                  <BiErrorCircle />
                </div>
                <div className="text">
                  Messsage um blablbablbalbalbalbalbalbalblablabl 
                </div>
            </div>
          </div>
        </div>
        <p>Ver todas</p>
      </DropMenuNotifications>
    );
  }
  function handleChangeTheme() {
    toggleTheme();
  }
  return (
    <Page>
      {openModalSignOut && (
        <ModalCofirm
          cancel={toggleLogout}
          confirm={signOut}
          title={"Tem certeza que deseja sair do sistema?"}
        />
      )}
      <div className="greeting">
        Olá, <span>{user.name}</span>
      </div>
      <div className="actions">
        <div className="action" onClick={handleChangeTheme}>
          {title === "light" ? <BiMoon /> : <BiSun />}
        </div>
        <Dropdown
          overlay={handleNotificantionClick}
          trigger={["click"]}
          placement="bottom"
        >
          <div className="action bell">
            <BiBell className="active-shake-animation" />
          </div>
        </Dropdown>

        <Dropdown
          overlay={handleProfileClick}
          trigger={["click"]}
          placement="bottom"
        >
          <div className="action">
            <BiUser />
          </div>
        </Dropdown>
      </div>
    </Page>
  );
};
export { Header };
